import { render } from "./purchases.vue?vue&type=template&id=758c224f"
import script from "./purchases.vue?vue&type=script&lang=js"
export * from "./purchases.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__